import { useCallback, useContext } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import {
  useForm,
  MultiStepFormContext,
  type StringIndexedObject,
} from '@kanda-libs/ks-component-ts';

export interface ApplyFormHook {
  form: UseFormReturn;
  onSubmit: (data: StringIndexedObject) => void;
}

export default function useApplyForm(): ApplyFormHook {
  const { data, handleContinue } = useContext(MultiStepFormContext);

  const form = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const onSubmit = useCallback(
    (submittedData: StringIndexedObject) => {
      if (handleContinue) {
        handleContinue({
          ...data,
          ...submittedData,
        });
      }
    },
    [data, handleContinue],
  );

  return {
    form,
    onSubmit,
  };
}
